<template>
  <div
    @mouseover="handleMouseOverTask"
    @mouseleave="handleMouseLeaveTask"
    class="checklist-table-body-row"
    :class="{ 
      'drop-disabled': isDragged || isParentSectionDragged,
    }"
  >
    <ChecklistTableTask
      :task="task"
      :parent="section"
      :is-dragged="isDragged"
    />
    <ChecklistTableDroppableArea
      v-if="isTaskDroppable"
      as="div"
      class="checklist-table-body-row"
      variant="after-task"
      @mouseUpDrop="onDropAfter"
      :section="section"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { mapGetters, mapMutations, mapState } from 'vuex' 

  import ChecklistTableTask from '@/project/checklist/table/ChecklistTableTask.vue'
  import { ChecklistSection, ChecklistTask } from '@/project/checklist/types'
  import { SET_CHECKLIST_DRAG_OVER_SECTION } from '@/store/modules/checklist/mutation_types'

  import ChecklistTableDroppableArea from './ChecklistTableDroppableArea.vue'
  
  export default defineComponent({
    name: 'ChecklistTableDroppableSection',
    props: {
      section: {
        type: Object as PropType<ChecklistSection>,
        required: true,
      },
      task: {
        type: Object as PropType<ChecklistTask>,
        required: true,
      },
    },
    emits: ['drop-after'],
    components: {
      ChecklistTableTask,
      ChecklistTableDroppableArea,
    },
    data() {
      return {
        draggingOverTaskId: null as number | null,
      }
    },
    computed: {
      ...mapState('checklist', ['checklistDragItem']),
      ...mapGetters('checklist', [ 'flatChecklist', 'isDraggingTask', 'isDraggingSection', 'prevChecklistDragItem' ]),
      isDragged () {
        return this.isDraggingTask && this.task.id === this.checklistDragItem?.id
      },
      isParentSectionDragged () {
        return this.isDraggingSection && this.section.id === this.checklistDragItem?.id
      },
      isTaskDropLineActive () {
        const isDraggingOverItself = this.draggingOverTaskId === this.task.id

        return isDraggingOverItself && this.isTaskDroppable
      },
      isTaskDroppable () {
        if(this.isDragged) return false

        if (this.prevChecklistDragItem?.id === this.task.id) {
          if(this.isDraggingTask && this.checklistDragItem?.depth === this.task.depth) return false
          if(this.isDraggingSection && this.checklistDragItem?.depth === Number(this.task.depth) + 1) return false
        }

        return !this.task.isAwaitingValidation
      },
    },
    methods: {
    ...mapMutations('checklist', [
      SET_CHECKLIST_DRAG_OVER_SECTION,
    ]),
      handleMouseOverTask () {
        if (this.checklistDragItem) {
          this.draggingOverTaskId = this.task.id
          this.SET_CHECKLIST_DRAG_OVER_SECTION(this.section)
        }
      },
      handleMouseLeaveTask() {
        this.draggingOverTaskId = null
        this.SET_CHECKLIST_DRAG_OVER_SECTION(null)
      },
      onDropAfter() {
        this.draggingOverTaskId = null
        this.$emit('drop-after', this.task)
      },
    },
  })
</script>